import React from 'react'

const Avatar = ({FirstName,LastName}) => {
  return (
    <div className='avatar avatar-blue'>
      {FirstName}{LastName}
    </div>
  )
}

export default Avatar
